define('glu/grid/paginate/paginationControls',['require','../../itemView','../../util','../../locale','hbs!./paginationControls.hbs','../../inputPlugins'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        util = require('../../util'),
        locale = require('../../locale'),
        tmpl = require('hbs!./paginationControls.hbs');

    require('../../inputPlugins'); // flexDropdown helper

    return ItemView.extend({
        template: tmpl,

        ui: {
            $pageSelect: '.paginate-page-select',
            $lastPageButton: '.last-page',
            $nextPageButton: '.next-page',
            $prevPageButton: '.prev-page',
            $firstPageButton: '.first-page'
        },

        events: {
            'change @ui.$pageSelect': 'handlePageSelect'
        },

        handlePageSelect: function(e) {
            var vals = this.$(e.currentTarget).flexDropdown('val');
            this.options.pager.handlePageSelect(vals[0]);
        },

        onBeforeClose: function() {
            this.ui.$pageSelect.flexDropdown('destroy');
        },

        templateHelpers: function() {
            return util.extend(this.options.data, {
                cid: this.cid
            });
        },

        onRender: function() {
            this.toggleActionButtons();
            this.initDropDown();
        },

        initDropDown: function() {
            this.ui.$pageSelect.flexDropdown({
                label: locale.get('page'), // missing 'sr-only' piece: 'number'
                showTooltip: false,
                disableMultiButton: true,
                preSelectedIds: [this.options.data.currentPageNumber],
                data: util.map(this.options.data.pages, function(page) {
                    return {
                        id: page,
                        name: page
                    };
                })
            });
        },

        toggleActionButtons: function() {
            // 0/number = zero in case if size of inputCollection equal to zero
            var totalPages = this.options.pager.getPageCount(),
                lastPage = this.options.pager.getCurrentPage() === totalPages,
                firstPage = this.options.pager.getCurrentPage() === 1;

            if (lastPage) {
                this.ui.$lastPageButton.attr('disabled', true);
                this.ui.$nextPageButton.attr('disabled', true);
            } else {
                this.ui.$lastPageButton.removeAttr('disabled');
                this.ui.$nextPageButton.removeAttr('disabled');
            }

            if (firstPage) {
                this.ui.$firstPageButton.attr('disabled', true);
                this.ui.$prevPageButton.attr('disabled', true);
            } else {
                this.ui.$firstPageButton.removeAttr('disabled');
                this.ui.$prevPageButton.removeAttr('disabled');
            }
        }
    });
});

